import { getGlassboxLogger } from '../../../../glassboxLogger';
import { getTooltipUxCopy } from './getTooltipUxCopy';
export const getDisabledControlContext = reason => ({
  disabled: true,
  reason,
  uxCopy: getTooltipUxCopy(reason)
});
export const getPaywallControlContext = (reason, productName) => ({
  disabled: true,
  paywall: {
    reason,
    logger: () => getGlassboxLogger().logLoadedPaywallCta({
      cta_paywall_type: 'PRIVACY_SETTINGS',
      paywall_cta_product: productName
    })
  },
  uxCopy: getTooltipUxCopy(reason)
});